module.exports = __webpack_public_path__ + "img/__icon_BDE.a005270f.svg";